// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-dialog[data-v-5130a572]{padding:10px}.modal-dialog h4[data-v-5130a572]{font-weight:700}.modal-dialog .dialog-buttons[data-v-5130a572]{display:flex;justify-content:flex-end;margin-top:10px}.modal-dialog .dialog-buttons[data-v-5130a572]>:not(:last-child){margin-right:10px}", ""]);
// Exports
module.exports = exports;
